import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/contact/EmailJsForm.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/contactBg.webp")